import { ICOMMAND, IKeyMaybeValue, IRESPONSE, RESULT } from "./command/icommand";
import { ACTION } from "./command/action";
import { MediaFile, MediaOffer, MessageParams } from "./message";
import { ComaSeparatedValues } from "./sessionstate";
import { baseParamsType } from "./command/baseparams";
import { EnumBooleanStringified } from "../@types";

export type templateCategoryType = {
  categoryId: string;
  categoryName: string;
  categoryDeleted?: EnumBooleanStringified;
};

export class CMDC_TPLCATEGORY implements ICOMMAND {
  public action: ACTION = ACTION.CMDC_TPLCATEGORY;
  public params: templateCategoryType;
}

export class CMDP_SGETTPLCATEGORIES implements ICOMMAND {
  public action = ACTION.CMDP_SGETTPLCATEGORIES;
  public params: baseParamsType;
}
export class CMDP_SGETTPLCATEGORIES_RESPONSE extends CMDP_SGETTPLCATEGORIES implements IRESPONSE {
  public result: RESULT;
  public commands: CMDC_TPLCATEGORY[];
  public values: IKeyMaybeValue;
}

export class CMDP_SUPSERTTPLCATEGORY implements ICOMMAND {
  public action = ACTION.CMDP_SUPSERTTPLCATEGORY;
  public params: baseParamsType & templateCategoryType;
}
export class CMDP_SUPSERTTPLCATEGORY_RESPONSE extends CMDP_SUPSERTTPLCATEGORY implements IRESPONSE {
  public result: RESULT;
  public commands: CMDC_TPLCATEGORY[];
  public values: IKeyMaybeValue;
}

export class CMDP_SDELETETPLCATEGORY implements ICOMMAND {
  public action = ACTION.CMDP_SDELETETPLCATEGORY;
  public params: baseParamsType & { categoryId: string };
}
export class CMDP_SDELETETPLCATEGORY_RESPONSE extends CMDP_SDELETETPLCATEGORY implements IRESPONSE {
  public result: RESULT;
  public commands: CMDC_TPLCATEGORY[];
  public values: IKeyMaybeValue;
}

export type messageTemplateType = MessageParams &
  MediaFile &
  MediaOffer & {
    templateId: string;
    templateName?: string;
    categoryId?: string;
    templateTags?: ComaSeparatedValues<string>;
    templateText?: string;
    templateCreated: string;
    templateChanged?: string;
    templateDeleted?: EnumBooleanStringified;
    templateSent?: string;
    templateBought?: string;
    favorite?: EnumBooleanStringified;
  };

export class CMDC_MSGTEMPLATE implements ICOMMAND {
  public action: ACTION = ACTION.CMDC_MSGTEMPLATE;
  public params: messageTemplateType;
}

export class CMDP_SGETMSGTEMPLATES implements ICOMMAND {
  public action = ACTION.CMDP_SGETMSGTEMPLATES;
  public params: baseParamsType & {
    categoryId?: string;
  };
}
export class CMDP_SGETMSGTEMPLATES_RESPONSE extends CMDP_SGETMSGTEMPLATES implements IRESPONSE {
  public result: RESULT;
  public commands: CMDC_MSGTEMPLATE[];
  public values: IKeyMaybeValue;
}

export class CMDP_SUPSERTMSGTEMPLATE implements ICOMMAND {
  public action = ACTION.CMDP_SUPSERTMSGTEMPLATE;
  public params: baseParamsType & messageTemplateType;
}
export class CMDP_SUPSERTMSGTEMPLATE_RESPONSE extends CMDP_SUPSERTMSGTEMPLATE implements IRESPONSE {
  public result: RESULT;
  public commands: CMDC_MSGTEMPLATE[];
  public values: IKeyMaybeValue;
}

export class CMDP_SDELETEMSGTEMPLATE implements ICOMMAND {
  public action = ACTION.CMDP_SDELETEMSGTEMPLATE;
  public params: baseParamsType & { msgTplId: string };
}
export class CMDP_SDELETEMSGTEMPLATE_RESPONSE extends CMDP_SDELETEMSGTEMPLATE implements IRESPONSE {
  public result: RESULT;
  public commands: CMDC_MSGTEMPLATE[];
  public values: IKeyMaybeValue;
}
